// AI 工具知识库 Mock 数据
// 能力分类映射（用于筛选）
const CATEGORIES = [
  { key: "text", label: "大模型 / 对话" },
  { key: "image", label: "文生图" },
  { key: "video", label: "视频 AI" },
  { key: "code", label: "代码 AI" },
  { key: "voice", label: "语音 / 音频" },
  { key: "agent", label: "Agent / 自动化" },
  { key: "ocr", label: "OCR" },
  { key: "writing", label: "AI 写作" },
];

// 价格模式
const PRICE_MODES = [
  { key: "free", label: "免费", color: "#00b42a" },
  { key: "freemium", label: "免费额度", color: "#14c9c9" },
  { key: "paid", label: "付费", color: "#ff7d00" },
];

const PLATFORMS = ["网页", "客户端", "API"];

// 工具数据
const tools = [
  {
    id: "chatgpt",
    name: "ChatGPT",
    logo: "https://chat.openai.com/favicon.ico",
    intro:
      "OpenAI 推出的旗舰级大模型对话助手，覆盖写作、编程、推理、创意等全场景。",
    url: "https://chat.openai.com",
    categories: ["text", "writing", "code"],
    tags: ["对话", "写作", "推理", "代码", "插件"],
    platforms: ["网页", "客户端", "API"],
    price: "freemium",
    priceText: "免费额度 / Plus $20/月",
    score: { overall: 9.4, ease: 9.2, effect: 9.6, value: 9.0 },
    pros: ["综合能力天花板", "生态与插件丰富", "支持联网与多模态"],
    cons: ["国内访问受限", "高峰期排队", "免费额度有限"],
    scene: "通用问答、内容创作、编程辅助、学习助手",
    heat: 99,
    addedAt: "2024-03-01",
    updateLogs: [
      { date: "2025-05-01", content: "发布 GPT-4o，原生支持音频与视觉" },
      { date: "2024-11-01", content: "上线 GPTs 应用市场" },
    ],
  },
  {
    id: "midjourney",
    name: "Midjourney",
    logo: "https://www.midjourney.com/favicon.ico",
    intro:
      "全球顶尖的文生图工具，艺术感与美学表现力最强，广泛用于概念设计、插画创作。",
    url: "https://www.midjourney.com",
    categories: ["image"],
    tags: ["文生图", "艺术", "插画", "设计"],
    platforms: ["网页", "Discord"],
    price: "paid",
    priceText: "$10/月起",
    score: { overall: 9.3, ease: 8.0, effect: 9.8, value: 8.8 },
    pros: ["出图审美极高", "风格统一可控", "迭代更新快"],
    cons: ["上手曲线较陡", "无免费额度", "依赖 Discord"],
    scene: "概念设计、插画、海报、游戏原画",
    heat: 95,
    addedAt: "2024-03-05",
    updateLogs: [
      { date: "2025-03-01", content: "上线 V7 版本，提示词理解显著增强" },
    ],
  },
  {
    id: "github-copilot",
    name: "GitHub Copilot",
    logo: "https://github.com/favicon.ico",
    intro:
      "AI 结对编程助手，可在 IDE 中实时补全代码、解释代码、生成测试，支持主流编辑器。",
    url: "https://github.com/features/copilot",
    categories: ["code"],
    tags: ["代码补全", "结对编程", "IDE", "代码生成"],
    platforms: ["客户端", "API"],
    price: "paid",
    priceText: "$10/月 或 $100/年",
    score: { overall: 9.1, ease: 9.4, effect: 9.0, value: 8.6 },
    pros: ["上下文感知强", "支持多语言多 IDE", "与仓库深度集成"],
    cons: ["对冷门框架支持一般", "收费无免费额度"],
    scene: "日常编码、测试生成、重构、代码解释",
    heat: 93,
    addedAt: "2024-03-10",
    updateLogs: [
      { date: "2025-04-01", content: "接入 Agent 模式，可跨文件自动改代码" },
    ],
  },
  {
    id: "claude",
    name: "Claude",
    logo: "https://claude.ai/favicon.ico",
    intro:
      "Anthropic 出品的长上下文大模型，擅长长文写作、代码分析与文档理解，风格更安全克制。",
    url: "https://claude.ai",
    categories: ["text", "writing", "code"],
    tags: ["对话", "长上下文", "写作", "代码", "分析"],
    platforms: ["网页", "客户端", "API"],
    price: "freemium",
    priceText: "免费额度 / Pro $20/月",
    score: { overall: 9.2, ease: 9.0, effect: 9.4, value: 8.9 },
    pros: ["200K 超长上下文", "写作自然有温度", "安全意识强"],
    cons: ["峰值负载限流", "复杂推理略逊"],
    scene: "长文档分析、报告写作、代码审查、论文润色",
    heat: 90,
    addedAt: "2024-03-15",
    updateLogs: [
      { date: "2025-06-01", content: "Claude 4 上线，原生支持多模态输入" },
    ],
  },
  {
    id: "stable-diffusion",
    name: "Stable Diffusion",
    logo: "https://stability.ai/favicon.ico",
    intro:
      "开源文生图模型，支持本地部署与全量自定义，配合 LoRA / ControlNet 玩法极多。",
    url: "https://stability.ai",
    categories: ["image"],
    tags: ["文生图", "开源", "本地部署", "图生图"],
    platforms: ["客户端", "API"],
    price: "free",
    priceText: "开源免费（在线有免费额度）",
    score: { overall: 8.7, ease: 6.5, effect: 8.8, value: 9.6 },
    pros: ["完全开源免费", "本地部署隐私安全", "生态扩展极丰富"],
    cons: ["上手门槛高", "硬件要求高", "默认效果需调参"],
    scene: "本地绘画、模型微调、批量生成、科研",
    heat: 88,
    addedAt: "2024-03-20",
    updateLogs: [
      { date: "2025-02-01", content: "SD 3.5 开放，细节与构图提升明显" },
    ],
  },
  {
    id: "kimi",
    name: "Kimi",
    logo: "https://www.moonshot.cn/favicon.ico",
    intro:
      "月之暗面出品的国产大模型，超长上下文处理中文资料、链接阅读与 PDF 解析体验优秀。",
    url: "https://www.moonshot.cn",
    categories: ["text", "writing"],
    tags: ["对话", "长上下文", "中文", "文件阅读"],
    platforms: ["网页", "客户端", "API"],
    price: "freemium",
    priceText: "免费额度 + 会员制",
    score: { overall: 8.9, ease: 9.3, effect: 8.9, value: 9.1 },
    pros: ["中文理解好", "免费额度充裕", "阅读链接/文件强"],
    cons: ["复杂推理一般", "部分场景回答较保守"],
    scene: "中文资料总结、PDF 阅读、联网搜索问答",
    heat: 86,
    addedAt: "2024-04-01",
    updateLogs: [{ date: "2025-01-01", content: "推出 Kimi K2 深度推理模型" }],
  },
  {
    id: "runway",
    name: "Runway",
    logo: "https://runway.com/favicon.ico",
    intro:
      "AI 视频生成与剪辑工具，支持文生视频、图生视频、视频修复与绿幕特效，创作流程一体化。",
    url: "https://runway.com",
    categories: ["video"],
    tags: ["文生视频", "视频编辑", "特效", "图生视频"],
    platforms: ["网页", "客户端"],
    price: "freemium",
    priceText: "免费额度 / Standard $15/月",
    score: { overall: 8.8, ease: 8.7, effect: 9.0, value: 8.2 },
    pros: ["视频质量领先", "工具链完整", "有免费试用"],
    cons: ["额度消耗快", "细节一致性待提升"],
    scene: "短视频、广告素材、影视前期预览",
    heat: 84,
    addedAt: "2024-04-10",
    updateLogs: [{ date: "2025-05-01", content: "Gen-4 支持人物一致性" }],
  },
  {
    id: "napkin",
    name: "Napkin AI",
    logo: "https://www.napkin.ai/favicon.ico",
    intro:
      "一句话把文字变成信息图的可视化工具，适合做 PPT、博客配图与内容传播素材。",
    url: "https://www.napkin.ai",
    categories: ["image"],
    tags: ["信息图", "可视化", "文案配图", "PPT"],
    platforms: ["网页"],
    price: "freemium",
    priceText: "免费额度 + Pro",
    score: { overall: 8.5, ease: 9.5, effect: 8.3, value: 9.0 },
    pros: ["上手零门槛", "生成样式美观", "节省配图时间"],
    cons: ["对中文排版一般", "可定制性有限"],
    scene: "PPT 配图、博客封面、内容海报",
    heat: 80,
    addedAt: "2024-05-01",
    updateLogs: [],
  },
  {
    id: "speech-t5",
    name: "ChatTTS / TTS 全家桶",
    logo: "https://github.com/2noise/ChatTTS/raw/main/logo.png",
    intro:
      "开源语音合成项目集合，涵盖 ChatTTS、Edge-TTS 等，支持中文自然语音与音色克隆。",
    url: "https://github.com/2noise/ChatTTS",
    categories: ["voice"],
    tags: ["语音合成", "开源", "音色克隆", "本地部署"],
    platforms: ["客户端", "API"],
    price: "free",
    priceText: "开源免费",
    score: { overall: 8.6, ease: 6.8, effect: 8.8, value: 9.5 },
    pros: ["中文音色自然", "完全免费", "可本地部署"],
    cons: ["需配置环境", "长文稳定性一般"],
    scene: "有声书、配音、视频旁白、智能客服",
    heat: 78,
    addedAt: "2024-05-15",
    updateLogs: [],
  },
  {
    id: "comfyui",
    name: "ComfyUI",
    logo: "https://www.comfy.org/favicon.ico",
    intro:
      "基于节点式工作流的 AI 绘画工具，将 SD 生图流程可视化，适合自动化批量生成与精细控制。",
    url: "https://www.comfy.org",
    categories: ["image"],
    tags: ["文生图", "节点工作流", "自动化", "本地部署"],
    platforms: ["客户端"],
    price: "free",
    priceText: "开源免费",
    score: { overall: 8.9, ease: 6.2, effect: 9.2, value: 9.6 },
    pros: ["流程高度可定制", "可复用工作流", "性能优化好"],
    cons: ["概念学习成本高", "对新手不友好"],
    scene: "批量出图、精细控制、稳定复现工作流",
    heat: 85,
    addedAt: "2024-06-01",
    updateLogs: [],
  },
  {
    id: "notion-ai",
    name: "Notion AI",
    logo: "https://www.notion.so/favicon.ico",
    intro:
      "Notion 内置 AI，在文档、知识库与数据库上下文中直接写作、总结、翻译、问答。",
    url: "https://www.notion.so",
    categories: ["writing", "text"],
    tags: ["文档", "知识库", "写作", "问答"],
    platforms: ["网页", "客户端"],
    price: "paid",
    priceText: "随工作区订阅",
    score: { overall: 8.4, ease: 9.0, effect: 8.2, value: 7.8 },
    pros: ["与知识库深度融合", "写作体验顺畅", "团队共享方便"],
    cons: ["依赖 Notion 生态", "单点能力不突出"],
    scene: "会议纪要、知识库问答、团队文档",
    heat: 76,
    addedAt: "2024-06-10",
    updateLogs: [],
  },
  {
    id: "paddle-ocr",
    name: "PaddleOCR",
    logo: "https://www.paddlepaddle.org.cn/favicon.ico",
    intro:
      "百度飞桨开源 OCR 工具包，中文识别精度高，支持版面分析、表格识别与 80+ 语言。",
    url: "https://github.com/PaddlePaddle/PaddleOCR",
    categories: ["ocr"],
    tags: ["OCR", "开源", "中文识别", "表格识别"],
    platforms: ["客户端", "API"],
    price: "free",
    priceText: "开源免费",
    score: { overall: 8.8, ease: 7.0, effect: 9.0, value: 9.7 },
    pros: ["中文识别顶尖", "支持表格/版面", "持续更新活跃"],
    cons: ["环境依赖较重", "英文场景略逊"],
    scene: "证件识别、票据数字化、文档归档、截图转文字",
    heat: 82,
    addedAt: "2024-07-01",
    updateLogs: [],
  },
];

// 精选合集
const collections = [
  {
    id: "local-llm",
    title: "本地部署合集",
    icon: "🖥️",
    desc: "可本地运行、数据私有的开源工具",
    toolIds: ["stable-diffusion", "comfyui", "speech-t5", "paddle-ocr"],
  },
  {
    id: "video-gen",
    title: "AI 视频生成",
    icon: "🎬",
    desc: "文生视频 / 视频创作热门工具",
    toolIds: ["runway"],
  },
  {
    id: "free-ocr",
    title: "免费 OCR 工具",
    icon: "📄",
    desc: "开源免费的文字识别方案",
    toolIds: ["paddle-ocr"],
  },
  {
    id: "daily-write",
    title: "写作效率套件",
    icon: "✍️",
    desc: "写作、总结、润色常用工具",
    toolIds: ["chatgpt", "claude", "kimi", "notion-ai"],
  },
  {
    id: "coding",
    title: "编程好帮手",
    icon: "💻",
    desc: "写代码、查代码的 AI 助手",
    toolIds: ["github-copilot", "chatgpt", "claude"],
  },
];

// 示例笔记（Markdown）
const notes = [
  {
    id: "note-1",
    toolId: "midjourney",
    title: "MJ 出图新手 prompt 框架",
    tags: ["文生图", "Prompt"],
    createdAt: "2024-06-20",
    author: "小不点",
    likes: 32,
    content:
      "这里是我的 **Midjourney Prompt 万能框架**：\n\n## 推荐公式\n`主题 + 风格 + 构图 + 光线 + 细节 + 参数`\n\n## 示例\n> 一位穿着汉服的少女站在樱花树下，宫崎骏动画风格，特写，柔和逆光，高清细节 --ar 3:4 --v 6\n\n## 常用参数\n- `--ar` 宽高比\n- `--v` 版本\n- `--stylize` 艺术化程度\n- `--no` 排除元素\n\n## 踩坑记录\n1. 不要堆叠过多风格词，容易互相污染\n2. 用 `--no` 控制负面元素比用否定词更有效",
  },
  {
    id: "note-2",
    toolId: "chatgpt",
    title: "用 ChatGPT 做结构化知识整理",
    tags: ["效率", "工作流"],
    createdAt: "2024-07-02",
    author: "小不点",
    likes: 21,
    content:
      "分享一个**信息整理工作流**：\n\n1. 先把资料丢给它，要求『总结成要点 + 保留关键数据』\n2. 再用追问拆解模糊点\n3. 最后让它输出 Markdown 表格对比\n\n## 效率技巧\n给模型设定**角色 + 输出格式**，结果质量会明显提升。\n\n```\n你是一位资深知识管理专家，请把以下内容整理为带小标题的笔记，并标注每个结论的依据。\n```",
  },
  {
    id: "note-3",
    toolId: "comfyui",
    title: "ComfyUI 本地部署记录（M 卡）",
    tags: ["本地部署", "踩坑"],
    createdAt: "2024-08-11",
    author: "小不点",
    likes: 15,
    content:
      "记录一次 **ComfyUI 部署踩坑**：\n\n## 环境\n- 显卡：RTX 4060\n- 显存：8G\n\n## 问题\n默认 sampler 下出图非常慢，显存溢出。\n\n## 解决方案\n- 使用 `--lowvram` 启动参数\n- 把采样器换为 **DPM++ 2M Karras**，步数 20\n- 用 FP16 模型 + VAE 修复补丁\n\n## 结果\n单张 512x768 出图时间从 8s 降到 3s。",
  },
  {
    id: "note-4",
    toolId: "paddle-ocr",
    title: "PaddleOCR 表格识别实战",
    tags: ["OCR", "实战"],
    createdAt: "2024-09-05",
    author: "小不点",
    likes: 9,
    content:
      "用 PaddleOCR 识别扫描版表格：\n\n1. 先用 `PP-StructureV2` 做版面分析\n2. 再调用表格识别引擎输出 HTML\n3. 通过 `pandas.read_html` 转成 DataFrame\n\n> 发票这类版式规整的表格识别率能达到 98% 以上。\n\n## 注意\n图片分辨率最好 ≥ 300dpi，预处理做灰度 + 二值化。",
  },
  {
    id: "note-5",
    toolId: null,
    title: "我的 AI 选型判断标准",
    tags: ["方法论", "选型"],
    createdAt: "2024-10-18",
    author: "小不点",
    likes: 45,
    content:
      "面对新 AI 工具，我的**判断框架**：\n\n1. **需求匹配**：核心场景是什么？工具是否直击痛点\n2. **成本**：免费额度够不够日常用\n3. **数据安全**：是否能本地部署 / 是否涉敏感数据\n4. **生态**：是否有 API、插件、社区教程\n5. **迭代速度**：近 3 个月更新是否频繁\n\n## 一句话结论\n> 没有最好的工具，只有最适合当前任务的工具。对比着用，各取所长。",
  },
];

export { CATEGORIES, PRICE_MODES, PLATFORMS, tools, notes, collections };
